/** 清除localStorage */
export const localStorageClear = () => {
  localStorage.Web_username = localStorage.isRemember === "Y" 
    ? localStorage.Web_username 
    : "";
  localStorage.cus_token = "";
  localStorage.Web_customerName = "";
  localStorage.customer_id = "";
};